import React, { useEffect, useState } from "react"
import { getInspiration, addInspiration } from "../../redux/Slice/inspirationSlice"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { useDispatch, useSelector } from "react-redux"
import { Card, CardMedia, CardContent, Typography, Button, IconButton, Dialog, DialogTitle, DialogContent, FormControl, FormLabel, TextField, DialogActions } from "@mui/material"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import Grid from "@mui/material/Grid2"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import { uploadImage } from "../../redux/Slice/imageSlice"
import { clearMessage } from "../../redux/Slice/message"
import { toast } from "sonner"
import { fetchUserProfile } from "../../redux/Slice/AuthSlice"
import { fetchService } from "../../redux/Slice/serviceslice"

export const Inspirations = () => {
  const [open, setOpen] = useState(false)
  const [newInspiration, setNewInspiration] = useState({})
  const [image, setImage] = useState(null)

  const dispatch = useDispatch()
  const { data: inspiration } = useSelector((state) => state.inspiration)
  const { imageUrl, success} = useSelector((state) => state.image)
  const message = useSelector((state) => state.message)
  const { data: services } = useSelector((state) => state.service)

  console.log("serv",imageUrl)

  const { user, profile, error } = useSelector((state) => state.auth)
  // console.log("pro",profile)

  useEffect(() => {
    dispatch(setLoading(true))
    // dispatch(fetchUserProfile())
    dispatch(fetchService())
    dispatch(getInspiration())
      .unwrap()
      .finally(() => {
        dispatch(setLoading(false))
      })
  }, [dispatch])

  



  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  const handleAddInspiration = () => {
    dispatch(setLoading(true))

    if (image && newInspiration) {
      const formData = new FormData()
      formData.append("image", image)
      dispatch(uploadImage(formData))
    }


    const formData = {
      ...newInspiration,
      usageType: "Decorative",
      role: profile?.data?.role,
      roleId: profile?.data?._id,
      imgUrls: [imageUrl],
    }

    dispatch(addInspiration(formData))
      .unwrap()
      .catch((error) => console.error(`Error: ${error.message}`))

    dispatch(setLoading(false))

    handleClose()
  }

  const handleEditInspiration = (id) => {}

  const handleDeleteInspiration = (id) => {}

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleFileChange = (e) => {
    setImage(e.target.files[0])
  }

  return (
    <div className="content">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant="h4">Inspiration</Typography>
        <Button variant="contained" color="primary" onClick={handleOpen}>
          Add
        </Button>
      </div>
      <Grid container spacing={4}>
        {inspiration?.map((item) => (
          <Grid item key={item._id}>
            <Card style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  display: "flex",
                  gap: "8px",
                }}
              >
                <IconButton onClick={() => handleEditInspiration(item._id)}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => handleDeleteInspiration(item._id)}>
                  <DeleteIcon />
                </IconButton>
              </div>
              <CardMedia component="img" height="150" image={item.imgUrls[0]} alt={item.name} />
              <CardContent>
                <Typography variant="h6">{item.name}</Typography>
                <Typography variant="body2" color="textSecondary">
                  Space Type: {item.spaceType}
                </Typography>
                {/* <Typography variant="body2" color="textSecondary">
                  Usage Type: {item.usageType}
                </Typography> */}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "450px",
          },
        }}
      >
        <DialogTitle>Add New Inspiration</DialogTitle>
        <DialogContent>
          <FormControl sx={{ marginBottom: "16px", width: "100%" }}>
            <FormLabel htmlFor="Inspiration-name" sx={{ textAlign: "start", marginBottom: "8px" }}>
              Name
            </FormLabel>
            <TextField
              id="Inspiration-name"
              name="Inspiration-name"
              type="text"
              placeholder="Enter..."
              fullWidth
              variant="outlined"
              onChange={(e) =>
                setNewInspiration({
                  ...newInspiration,
                  name: e.target.value,
                })
              }
              sx={{ marginBottom: "16px" }}
            />

            <FormLabel htmlFor="space-type" sx={{ textAlign: "start", marginBottom: "8px" }}>
              Space Type
            </FormLabel>
            <select
              id="space-type"
              name="space-type"
              value={newInspiration.spaceType || ""}
              onChange={(e) =>
                setNewInspiration({
                  ...newInspiration,
                  spaceType: e.target.value,
                })
              }
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginBottom: "16px",
              }}
            >
              <option value="" hidden>
                Select Space Type
              </option>
              <option value="space1">space1</option>
              <option value="space2">space2</option>
            </select>

            <FormLabel htmlFor="service-type" sx={{ textAlign: "start", marginBottom: "8px" }}>
              Service Type
            </FormLabel>
            <select
              id="service-type"
              name="service-type"
              value={newInspiration.serviceId}
              onChange={(e) =>
                setNewInspiration({
                  ...newInspiration,
                  serviceId: e.target.value,
                })
              }
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginBottom: "16px",
              }}
            >
              <option value="" hidden>
                Select Service Type
              </option>
              {services?.map((service) => (
                <option key={service._id} value={service._id}>
                  {service.name}
                </option>
              ))}
            </select>

            <FormLabel  sx={{ textAlign: "start", marginBottom: "8px" }}>
              Upload Image
            </FormLabel>
            <input id="Inspiration-image" name="Inspiration-image" type="file" accept="image/*" onChange={handleFileChange} style={{ display: "none" }} />
            <FormLabel htmlFor="Inspiration-image" style={{ display: "block", marginTop: "8px" }}>
              <Button variant="outlined" color="primary" component="span" startIcon={<CloudUploadIcon />}  fullWidth sx={{ marginTop: "8px" }}>
                 Upload
              </Button>
            </FormLabel>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleAddInspiration} color="primary" >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
